import { NgModule } from '@angular/core';
import { BillableListComponent } from './billable-list/billable-list.component';
import { BillableEditComponent } from './billable-edit/billable-edit.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    BillableListComponent,
    BillableEditComponent
  ]
})
export class BillableModule { }
